export const BRIDGE_EXPERIMENT_NAME = "web23_ads_funnel_v1";
export const BRIDGE_QUIZ_URL = "https://quiz.builtwithscience.com/";
export const BRIDGE_CONTROL_URL = "https://builtwithscience.com/";
export const BRIDGE_CONTROL_REDIRECT_PARAM = "bws_quiz_redirect";
export const BRIDGE_CONTROL_REDIRECT_VALUE = "bridge_control";

export function buildBridgeControlRedirectValue(bridgeName?: string | null) {
  return bridgeName ? `${bridgeName}_bridge_control` : BRIDGE_CONTROL_REDIRECT_VALUE;
}

export function buildBridgeControlRedirectUrl(search: string) {
  const searchParams = new URLSearchParams(search);
  const bridgeName = searchParams.get("utm_angle");
  const redirectUrl = new URL(BRIDGE_CONTROL_URL);
  redirectUrl.search = search;
  redirectUrl.searchParams.delete("utm_angle");
  redirectUrl.searchParams.set(
    BRIDGE_CONTROL_REDIRECT_PARAM,
    buildBridgeControlRedirectValue(bridgeName)
  );
  return redirectUrl.toString();
}

export function buildBridgeControlRedirectUrlFromQuizUrl(quizUrl: string) {
  return buildBridgeControlRedirectUrl(new URL(quizUrl).search);
}
